import { Shader } from "./Shader";

// ShaderType maps to the filename of the shader
export enum ShaderType {
  BASIC = "basicShader",
  BLINN_NO_TEXTURE = "blinnNoTexture",
  BLINN_DIFFUSE_TEXTURE = "blinnTexture",
  BLINN_NORMAL_TEXTURE = "blinnDiffuseAndNormal",
};

export const getExportedShaderType = (s: ShaderType): number => {
  const shaderValues = Object.values(ShaderType);
  return shaderValues.indexOf(s);
};

export const getShaderTypeFromExported = (index: number):ShaderType => {
  const shaderList = Object.values(ShaderType);
  return shaderList[index];
}

export type StaticShaderData = {
  f: string;
  v: string;
  attribs: string[];
  uniforms: string[];
}

export class ShaderManager {
  public shaders: { [key: string]: Shader };

  constructor(sdata: { [key: string]: StaticShaderData }) {
    this.shaders = {};
    Object.keys(sdata).forEach((k) => {
      const s = sdata[k];
      // a bit ugly here to use `atob` but it works :shrug:
      const v = atob(s.v);
      const f = atob(s.f);
      this.shaders[k] = new Shader(v, f, s.uniforms, s.attribs);
    });
  }

  compileAll(gl: WebGL2RenderingContext) {
    Object.keys(this.shaders).forEach((s) => {
      this.shaders[s].compileProgram(gl, s);
    });
  }

  getShader(name: string): Shader {
    if (name in this.shaders) {
      return this.shaders[name];
    }
    throw new Error(`No shader by name of ${name}`);
  }
}
